import { render, staticRenderFns } from "./educationTextBook.vue?vue&type=template&id=7a3a8b64"
import script from "./educationTextBook.vue?vue&type=script&lang=js"
export * from "./educationTextBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a3a8b64')) {
      api.createRecord('7a3a8b64', component.options)
    } else {
      api.reload('7a3a8b64', component.options)
    }
    module.hot.accept("./educationTextBook.vue?vue&type=template&id=7a3a8b64", function () {
      api.rerender('7a3a8b64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/result/educationTextBook.vue"
export default component.exports